export default __webpack_public_path__ + "static/media/sunny.beeba150.mp4";